import React, { useEffect, useState } from 'react'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import EventBoxCel from '../EventBoxCel';
import { getAllEventLists } from '../../../networkCalls';

const Eventboxtab = () => {

    const state = {
        responsive: {
            0: {
                items: 1,
            },
            450: {
                items: 1,
            },
            600: {
                items: 2,
            },
            1000: {
                items: 4,
            },
        },
    };

    const [loading, setLoading] = useState(false);
    const [resultData, setResultData] = React.useState([]);
    const [page, setPage] = React.useState(1);
    const pullEventApi = () => {
        var data = new FormData();
         data.append("page", page);
        setLoading(true);
        getAllEventLists(data).then((res) => {
            setLoading(false);
            switch (res.data.status) {
                case 1:
                    setResultData(res?.data?.eventList)
                    //setErrMessage('');
                    return true;
                case 0:
                    //setErrMessage(res.data.msz);
                    break;
                default:
                    return;
            }
        })
    }

    useEffect(() => {
        pullEventApi();
    }, []);

    return (
        <div>
            {loading ? <></> : <>
                {resultData && resultData?.length > 0 ? <>
                    <OwlCarousel className='owl-theme with-nav-bottom-center' autoplay={false} items={4} nav={true} dots={false} responsive={state.responsive}>
                        {resultData && resultData?.map(data =>
                            <div key={data?.dataId} className="p-2">
                                <EventBoxCel item={data} />
                            </div>
                        )}
                    </OwlCarousel>
                </> : <></>}
            </>}
        </div>
    )
}

export default Eventboxtab